function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import classNames from 'classnames';
import { Form, Formik } from 'formik';
import React from 'react';
import { useDispatch } from 'react-redux';
import { Redirect, useHistory } from 'react-router-dom';
import { PulseLoader } from 'react-spinners';
import { useAsync, useSearchParam } from 'react-use';
import * as yup from 'yup';
import { Button } from '../components/button';
import FormContainer from '../components/containers/FormContainer';
import { PasswordFormControl } from '../components/form';
import Page from '../components/page/Page';
import { alertConstants } from '../redux/constants';
import routes from '../routes/constants';
import text from '../text';
import { larkiApiNoAuthentication } from '../utilities/api';
import { setUser } from '../utilities/storage';
import { validatePassword } from '../validation';
var createPasswordSchema = yup.object({
    password: validatePassword
});
var initialValues = {
    password: ''
};
var CreatePassword = function() {
    var dispatch = useDispatch();
    var history = useHistory();
    var token = useSearchParam('token');
    var coupon = useSearchParam('coupon');
    var redirectUrl = useSearchParam('redirectUrl');
    var onRevisit = useSearchParam('onRevisit');
    if (!token) {
        return /*#__PURE__*/ React.createElement(Redirect, {
            to: routes.home
        });
    }
    var _useAsync = useAsync(/*#__PURE__*/ _async_to_generator(function() {
        var data;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        larkiApiNoAuthentication.post('/user/verify-token', {
                            token: token
                        })
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data.token
                    ];
            }
        });
    }), [
        token
    ]), loading = _useAsync.loading, error = _useAsync.error, value = _useAsync.value;
    if (error) {
        return /*#__PURE__*/ React.createElement(Redirect, {
            to: routes.login
        });
    }
    var onSubmit = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(param) {
            var password, data, search, error;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        password = param.password;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            larkiApiNoAuthentication.post('/user/set-initial-password', {
                                password: password
                            }, {
                                headers: {
                                    Authorization: "Bearer ".concat(value)
                                },
                                params: {
                                    coupon: coupon
                                }
                            })
                        ];
                    case 2:
                        data = _state.sent().data;
                        sessionStorage.clear();
                        setUser(data);
                        search = new URLSearchParams(_object_spread({}, coupon && {
                            coupon: coupon
                        }, onRevisit && {
                            onRevisit: onRevisit
                        }));
                        history.push({
                            pathname: redirectUrl || routes.home,
                            search: search.toString(),
                            state: {
                                validated: true
                            }
                        });
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        dispatch({
                            type: alertConstants.ALERT_ERROR,
                            payload: {
                                message: error.response.data.message
                            }
                        });
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function onSubmit(_) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ React.createElement(Page, {
        className: classNames('Signup', {
            PageCenter: loading
        })
    }, loading ? /*#__PURE__*/ React.createElement(PulseLoader, {
        size: 12,
        color: "#31a283"
    }) : /*#__PURE__*/ React.createElement(FormContainer, null, /*#__PURE__*/ React.createElement(FormContainer.SecondaryHeader, null, /*#__PURE__*/ React.createElement("h2", null, text('createPassword'))), /*#__PURE__*/ React.createElement(FormContainer.Body, null, /*#__PURE__*/ React.createElement(FormContainer.PrimaryHeader, null, /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("h2", null, text('createPassword'))), /*#__PURE__*/ React.createElement("p", null, text('createPasswordDescription'))), /*#__PURE__*/ React.createElement(Formik, {
        initialValues: initialValues,
        validationSchema: createPasswordSchema,
        onSubmit: onSubmit
    }, function(param) {
        var values = param.values, errors = param.errors, touched = param.touched, isSubmitting = param.isSubmitting, handleChange = param.handleChange, dirty = param.dirty;
        return /*#__PURE__*/ React.createElement(Form, null, /*#__PURE__*/ React.createElement(PasswordFormControl, {
            required: true,
            as: "input",
            name: "password",
            value: (values === null || values === void 0 ? void 0 : values.password) || '',
            onChange: handleChange,
            placeholder: text('enterPassword'),
            label: text('password'),
            autoComplete: "off",
            isFailed: touched.password && Boolean(errors.password),
            validationError: errors.password
        }), /*#__PURE__*/ React.createElement("div", {
            className: "text-center"
        }, /*#__PURE__*/ React.createElement("div", {
            className: "btns-group"
        }, /*#__PURE__*/ React.createElement(Button, {
            type: !isSubmitting && 'submit',
            className: "full-width",
            loading: isSubmitting,
            disabled: !dirty
        }, text('continue')))));
    }))));
};
export default CreatePassword;
